/**
 * ShreemTech Universal Admin Panel
 * Copyright (c) 2026 ShreemTech Ltd. All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL — TRADE SECRET
 */

// BFF routes live on the same origin as the Next.js app — no prefix needed.
const API_URL = "";

export async function apiCall<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
  const token =
    typeof document !== "undefined"
      ? document.cookie.match(/shreem-session=([^;]+)/)?.[1] ?? ""
      : "";

  let sessionToken = "";
  if (token) {
    try {
      const session = JSON.parse(decodeURIComponent(token));
      sessionToken = session?.accessToken ?? "";
    } catch {
      sessionToken = "";
    }
  }

  let response: Response;
  try {
    response = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...(sessionToken ? { Authorization: `Bearer ${sessionToken}` } : {}),
        ...options.headers,
      },
    });
  } catch (err) {
    // Network error, DNS failure, or timeout — surface a clean message
    const msg = err instanceof Error ? err.message : "Network error";
    throw new Error(`Service unavailable: ${msg}`);
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: response.statusText }));
    throw new Error((error as { message?: string }).message || `HTTP ${response.status}`);
  }

  return response.json() as Promise<T>;
}
